import { STORYLINE_TITLES, DEFAULT_TITLE } from 'config/titles';

export const updateDocumentTitle = (storylineDetails, storylineInstanceDetails) => {
    if (storylineDetails && storylineDetails.id) {
        let title = STORYLINE_TITLES[storylineDetails.id] || storylineDetails.name || DEFAULT_TITLE;
        document.title = title;
    } else {
        document.title = DEFAULT_TITLE;
    }
};

export const setInitialTitle = () => {
    document.title = DEFAULT_TITLE;
};

export default {
    updateDocumentTitle,
    setInitialTitle
};
